import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elementZhtwLocale from 'element-ui/lib/locale/lang/zh-TW' // element-ui lang
import zhLocale from './zh-cn'
import zhtwLocale from './zh-tw'

Vue.use(VueI18n)

const messages = {
  zhtw: {
    ...zhtwLocale,
    ...elementZhtwLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }
}

const i18n = new VueI18n({
  locale: Cookies.get('language') || 'zh', // set locale
  messages // set locale messages
})

export default i18n


// WEBPACK FOOTER //
// ./src/lang/index.js